module.exports = __webpack_public_path__ + "03_short_black.da9c74ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_short_black.png
// module id = b7r4
// module chunks = 0